import { Card, Grid, Tab, Tabs } from "@mui/material";
import { SyntheticEvent, useState } from "react";
import Layout from "components/Layout";
import Quotes from "components/securities/Quotes";
import SecurityMaster from "components/securities/SecurityMaster";

const SecuritiesPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Layout title="Securities">
      <Card>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Security Master" />
          <Tab label="Quotes" />
        </Tabs>
        <Grid container>
          {activeTab === 0 && (
            <Grid item xs={12} padding={2}>
              <SecurityMaster />
            </Grid>
          )}
          {activeTab === 1 && (
            <Grid item xs={12} padding={2}>
              <Quotes />
            </Grid>
          )}
        </Grid>
      </Card>
    </Layout>
  );
};

export default SecuritiesPage;
